import {
  getPathByTypeAndGender,
  toAbsoluteUrl,
} from "../../../src/utils/getBaseUrl";

/**
 * Returns the absolute URL for a brand page based on gender, brand slug, and locale.
 *
 * @param gender - The gender for which the brand page is being generated (e.g., "women", "men").
 * @param brandSlug - The URL slug of the brand.
 * @param locale - The locale to use for the URL.
 * @returns The absolute URL string for the brand page or undefined if the URL cannot be generated.
 */
export const getBrandUrl = (
  brandSlug: string,
  locale: string,
  gender: string
): string | undefined => {
  const brandPath = getPathByTypeAndGender({
    type: "brand",
    gender: gender.toLowerCase() || "women",
    slug: brandSlug,
    locale,
  });
  if (brandPath) {
    return toAbsoluteUrl(brandPath);
  }
  return undefined;
};
